import { jsx as _jsx } from "react/jsx-runtime";
import Grid2 from "@mui/material/Grid2";
import { CsValueController } from "@plansoft-configuration-renderer/framework";
import { useGridLayoutPropsFromContext, } from "./useGridLayoutProps";
function GridFragment({ children }) {
    return children;
}
export function ValuesGrid(props) {
    const { values, ValueDisplayComponent = GridFragment } = props;
    const { gridEnabled, gridDirection, gridRowSpacing, gridColumnSpacing, gridBreakpoints, gridContainerSx, } = useGridLayoutPropsFromContext(props);
    const GridOrFragment = gridEnabled ? Grid2 : GridFragment;
    return (_jsx(GridOrFragment, { container: true, direction: gridDirection, rowSpacing: gridRowSpacing, columnSpacing: gridColumnSpacing, sx: gridContainerSx, children: values.map((value) => (_jsx(GridOrFragment, { size: gridBreakpoints, children: _jsx(CsValueController, { value: value, children: _jsx(ValueDisplayComponent, { children: props.children }) }) }, value.id))) }));
}
//# sourceMappingURL=ValuesGrid.js.map